export default {"src":"/_next/static/media/ticket.18319d9e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};